// ABOUTME: Component for displaying athlete name in a consistent format
// ABOUTME: Uses firstName and lastName with fallback to "-" if not available

import type { Maybe } from "@/graphql/main/gql/graphql"
import React from "react"

interface IAthleteName {
  athlete: {
    firstName?: Maybe<string>
    lastName?: Maybe<string>
  }
}

export const AthleteName = React.memo((props: IAthleteName) => {
  const { athlete } = props

  return (
    <>
      {athlete.firstName || "-"} {athlete.lastName || "-"}&nbsp;
    </>
  )
})
